<script lang="ts" setup>
import { nextTick, onMounted, ref } from "vue";

const emit = defineEmits(["update:modelValue"]);

const digit1 = ref();
const digit2 = ref();
const digit3 = ref();
const digit4 = ref();
const digit5 = ref();
const digit6 = ref();

const digits = [digit1, digit2, digit3, digit4, digit5, digit6];

const inputDigit = (event: InputEvent) => {
  const target = event.target as HTMLInputElement;
  let index = 0;
  for (const attr of target.attributes) {
    if (attr.name === "data-index") {
      index = parseInt(attr.value, 10);
    }
  }
  const [first, ...rest] = target.value;
  digits[index].value.value = first ?? "";
  if (first && index < digits.length - 1) {
    digits[index + 1].value.focus();
    digits[index + 1].value.value = rest.join("");
    digits[index + 1].value.dispatchEvent(new Event("input"));
  }
  emit(
    "update:modelValue",
    [
      digit1.value.value,
      digit2.value.value,
      digit3.value.value,
      digit4.value.value,
      digit5.value.value,
      digit6.value.value,
    ].join("")
  );
};

const onKeydown = (event: KeyboardEvent) => {
  const target = event.target as HTMLInputElement;
  if (event.key === "Backspace" && !target.value) {
    let index = 0;
    for (const attr of target.attributes) {
      if (attr.name === "data-index") {
        index = parseInt(attr.value, 10);
      }
    }
    if (index > 0) {
      digits[index - 1].value.focus();
    }
  }
};

onMounted(async () => {
  await nextTick();
  setTimeout(() => {
    digit1.value.focus();
  }, 500);
});
</script>

<template>
  <div class="flex flex-col items-center gap-y-4">
    <div class="flex gap-x-2">
      <input
        ref="digit1"
        type="text"
        inputmode="numeric"
        name="digit1"
        id="digit1"
        data-index="0"
        class="h-10 w-8 rounded-sm border text-center text-xl font-medium shadow-xs focus:ring-2 focus:ring-primary"
        @input="($event) => inputDigit($event as InputEvent)"
        @keydown="($event) => onKeydown($event as KeyboardEvent)"
      />
      <input
        ref="digit2"
        type="text"
        inputmode="numeric"
        name="digit2"
        id="digit2"
        data-index="1"
        class="h-10 w-8 rounded-sm border text-center text-xl font-medium shadow-xs focus:ring-2 focus:ring-primary"
        @input="($event) => inputDigit($event as InputEvent)"
        @keydown="($event) => onKeydown($event as KeyboardEvent)"
      />
      <input
        ref="digit3"
        type="text"
        inputmode="numeric"
        name="digit3"
        id="digit3"
        data-index="2"
        class="h-10 w-8 rounded-sm border text-center text-xl font-medium shadow-xs focus:ring-2 focus:ring-primary"
        @input="($event) => inputDigit($event as InputEvent)"
        @keydown="($event) => onKeydown($event as KeyboardEvent)"
      />
      <input
        ref="digit4"
        type="text"
        inputmode="numeric"
        name="digit4"
        id="digit4"
        data-index="3"
        class="h-10 w-8 rounded-sm border text-center text-xl font-medium shadow-xs focus:ring-2 focus:ring-primary"
        @input="($event) => inputDigit($event as InputEvent)"
        @keydown="($event) => onKeydown($event as KeyboardEvent)"
      />
      <input
        ref="digit5"
        type="text"
        inputmode="numeric"
        name="digit5"
        id="digit5"
        data-index="4"
        class="h-10 w-8 rounded-sm border text-center text-xl font-medium shadow-xs focus:ring-2 focus:ring-primary"
        @input="($event) => inputDigit($event as InputEvent)"
        @keydown="($event) => onKeydown($event as KeyboardEvent)"
      />
      <input
        ref="digit6"
        type="text"
        inputmode="numeric"
        name="digit6"
        id="digit6"
        data-index="5"
        class="h-10 w-8 rounded-sm border text-center text-xl font-medium shadow-xs focus:ring-2 focus:ring-primary"
        @input="($event) => inputDigit($event as InputEvent)"
        @keydown="($event) => onKeydown($event as KeyboardEvent)"
      />
    </div>
  </div>
</template>
